module.exports = __webpack_public_path__ + "static/img/project-darp.d7f0df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-darp.png
// module id = +2XE
// module chunks = 0